import { NameBanner } from '@rumblefish/ui/Rumblefish23Theme';
import type { FC } from 'react';
import type { JobPostSectionProps } from './JobPost.types';
import { StyledSection, StyledTitle, JobPostSectionContainer } from './styles';

export const JobPostSection: FC<JobPostSectionProps> = ({
  banner,
  title,
  children,
}) => {
  return (
    <StyledSection width="normal" mobilePadding>
      <JobPostSectionContainer>
        {banner && <NameBanner type="section" text={banner} color="orange" />}
        <StyledTitle variant="display_sm">{title}</StyledTitle>
        {children}
      </JobPostSectionContainer>
    </StyledSection>
  );
};
